import { MainLayout } from '@components/layout';
import { LanguageRedirectWrapper } from '@components/layout/LanguageRedirectWrapper';
import { NotFoundPage } from '@components/shared/NotFoundPage/NotFoundPage';
import { TidioController } from '@components/shared/TidioController';
import { SpecialistSwitch } from '@features/dashboard/specialistDashboard/specialistSwitchLayout/SpecialistSwitchLayout';
import { Chat } from '@pages/Chat';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute, RoleGuard } from './guards';
import {
	AdminRoutes,
	FarmerRoutes,
	PublicRoutes,
	RegistrationRoutes,
	SpecialistRoutes,
} from './routes';

export const AppRoutes = () => {
	return (
		<Router>
			<TidioController />
			<Routes>
				<Route element={<LanguageRedirectWrapper />}>
					<Route path="/" element={<Navigate to="/ka/login" />} />
					{PublicRoutes}
					<Route
						path="/:language"
						element={
							<ProtectedRoute>
								<MainLayout key={new Date().getTime()} />
							</ProtectedRoute>
						}
					>
						{SpecialistRoutes}
						{FarmerRoutes}
						{AdminRoutes}
						<Route
							path="specialist-switcher"
							element={
								<RoleGuard allowedRole="specialist">
									<SpecialistSwitch />
								</RoleGuard>
							}
						/>
						{RegistrationRoutes}
						
						{/* Catch-all route for invalid paths within protected routes */}
						<Route path="*" element={<Navigate to="login" replace />} />
					</Route>
					<Route path="chat" element={<Chat />} />
					<Route path="*" element={<NotFoundPage />} />
				</Route>
			</Routes>
		</Router>
	);
};
